import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { MatchData } from "@/interfaces/liveGamesType";
export const fetchGetHistMatches = (
  date: Date,
  options?: Partial<UseQueryOptions<MatchData[]>>,
  isAuth?: boolean
) => {
  const response = useQuery({
    queryKey: ["/football/getHistMatches", date],
    queryFn: async () => {
      const formattedDate = format(date, "yyyy-MM-dd");
      if (isAuth) {
        const res = await api.get(`/football/getHistMatches`, {
          params: {
            from: formattedDate,
            to: formattedDate,
          },
        });
        return res.data.data || [];
      }

      const res = await api.get("/football/getHistMatchesFree", {
        params: {
          from: formattedDate,
          to: formattedDate,
        },
      });
      return res.data.data || [];
    },
    ...options,
  });

  return {
    ...response,
    data: response.data || [],
  };
};
